// src/mocks/handlers/playerProgress.ts
import type { MockRequest } from '.'
import type { RootState } from '@/store'
import { infiniteDelay } from '../delays'

export const playerProgressHandler = async (req: MockRequest) => {
  const state = req.api.getState() as RootState
  const mode = state.dev.mockStates.playerProgress
  if (mode === 'loading') return infiniteDelay()
  if (mode === 'error') return { error: { status: 500, data: { detail: 'mock error' } } }
  if (mode === 'empty') return { data: { completedLessonIds: [] } }
  if (mode === 'partial') return { data: { completedLessonIds: [1, 2] } }
  return { data: { completedLessonIds: [1, 2, 3, 4, 5] } }
}
